"use client";
import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import LocomotiveScroll from "locomotive-scroll";
import "locomotive-scroll/dist/locomotive-scroll.css";

import './App.css';
import Header from './Component/Header';
import Footer from './Component/Footer';

import Typewriter from './Component/Typewriter';
import Imagemotion from './Component/Imagemotion';
import Earthvideo from './videos/earth_video.mp4';
import Features from './Component/Features';
import mydata from '../src/portfolio.json';

function App() {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const scroll = new LocomotiveScroll({
      el: containerRef.current,
      smooth: true,
      lerp: 0.1,
    });

    return () => {
      if (scroll) scroll.destroy();
    };
  }, []);

  return (
    <div className="App">
      <Header />
      <main
        data-scroll-container
        ref={containerRef}
      >
        <div className="hero_section">
          <div className="hero_video">
            <video autoPlay loop muted playsInline width="100%" height="100%">
              <source src={Earthvideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
          <div className="hero_content">
            <div className="page_wrapper">
              <h1>Akash Sen</h1>

              <Typewriter />
              <p>I'm a Full Stack Developer passionate about building seamless user experiences and powerful back-end systems—bridging design and technology to create meaningful digital products.</p>
            </div>
          </div>
        </div>

        <div className="home-section-4">
          <div className="marquee-top reserve">
            <ul className="top-bar-marqee">
              <li>Logo Design</li>
              <li>Brand Identity</li>
              <li>Website UI Design</li>
              <li>Website UX design</li>
              <li>Website Development</li>
            </ul>
            <ul className="top-bar-marqee">
              <li>Logo Design</li>
              <li>Brand Identity</li>
              <li>Website UI Design</li>
              <li>Website UX design</li>
              <li>Website Development</li>
            </ul>
          </div>
        </div>

        <div className='page_wrapper framer_under'>
          <div className="framer_img">
            <Imagemotion />
          </div>
          <div className="can_do_it">
            <div className="under_wrapper">
              <Features />
            </div>
          </div>

          <div className='about_me_section'>
            <div className='under_wrapper'>
              <div className='inner_about_me'>
                <h2>About Me</h2>
                <p>I'm a passionate Full Stack Developer with expertise in building dynamic web applications. I love turning ideas into reality through code and design.</p>
                <div className='about_me_counter'>
                  <ul>
                    <li><span>12</span>Years of Experience</li>
                    <li><span>270</span>Completed Projects</li>
                    <li><span>50+</span>Clients on Worldwide</li>
                  </ul>
                </div>

                <div className='about_me_info'>
                  <ul>
                    <li><span>Call Today:</span> <a href="tel:+15551234567">+91 8770562180</a></li>
                    <li><span>Email Me:</span> <a href="mailto:akashsen127@gmail.com">akashsen127@gmail.com</a></li>
                  </ul>
                </div>

                <div className='about_me_social'>
                  <ul>
                    <li>
                      <a href="https://twitter.com/yourprofile" target="_blank" rel="noopener noreferrer">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" role="img" aria-label="Twitter">
                          <path fill="#fff" d="M22.46 6c-.77.35-1.6.58-2.47.69a4.3 4.3 0 0 0 1.88-2.37 8.6 8.6 0 0 1-2.72 1.04 4.3 4.3 0 0 0-7.32 3.92A12.2 12.2 0 0 1 3.16 4.6a4.29 4.29 0 0 0 1.33 5.74 4.28 4.28 0 0 1-1.95-.54v.05a4.3 4.3 0 0 0 3.45 4.21c-.45.12-.92.18-1.4.18-.34 0-.67-.03-.99-.09a4.31 4.31 0 0 0 4.02 2.98A8.63 8.63 0 0 1 2 19.54 12.16 12.16 0 0 0 8.29 21c7.55 0 11.68-6.26 11.68-11.68 0-.18-.01-.36-.02-.53A8.36 8.36 0 0 0 22.46 6z" />
                        </svg>
                      </a>
                    </li>
                    <li>
                      <a href="https://twitter.com/yourprofile" target="_blank" rel="noopener noreferrer">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" role="img" aria-label="Twitter">
                          <path fill="#fff" d="M22.46 6c-.77.35-1.6.58-2.47.69a4.3 4.3 0 0 0 1.88-2.37 8.6 8.6 0 0 1-2.72 1.04 4.3 4.3 0 0 0-7.32 3.92A12.2 12.2 0 0 1 3.16 4.6a4.29 4.29 0 0 0 1.33 5.74 4.28 4.28 0 0 1-1.95-.54v.05a4.3 4.3 0 0 0 3.45 4.21c-.45.12-.92.18-1.4.18-.34 0-.67-.03-.99-.09a4.31 4.31 0 0 0 4.02 2.98A8.63 8.63 0 0 1 2 19.54 12.16 12.16 0 0 0 8.29 21c7.55 0 11.68-6.26 11.68-11.68 0-.18-.01-.36-.02-.53A8.36 8.36 0 0 0 22.46 6z" />
                        </svg>
                      </a>
                    </li>
                    <li>
                      <a href="https://twitter.com/yourprofile" target="_blank" rel="noopener noreferrer">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" role="img" aria-label="Twitter">
                          <path fill="#fff" d="M22.46 6c-.77.35-1.6.58-2.47.69a4.3 4.3 0 0 0 1.88-2.37 8.6 8.6 0 0 1-2.72 1.04 4.3 4.3 0 0 0-7.32 3.92A12.2 12.2 0 0 1 3.16 4.6a4.29 4.29 0 0 0 1.33 5.74 4.28 4.28 0 0 1-1.95-.54v.05a4.3 4.3 0 0 0 3.45 4.21c-.45.12-.92.18-1.4.18-.34 0-.67-.03-.99-.09a4.31 4.31 0 0 0 4.02 2.98A8.63 8.63 0 0 1 2 19.54 12.16 12.16 0 0 0 8.29 21c7.55 0 11.68-6.26 11.68-11.68 0-.18-.01-.36-.02-.53A8.36 8.36 0 0 0 22.46 6z" />
                        </svg>
                      </a>
                    </li>
                  </ul>
                </div>

                <Link to="/about" className='btn btn_my_story'>My Story</Link>
              </div>
            </div>
          </div>
        </div>

        <div className="our_projects">
          <div className="page_wrapper">
            <div className="titles">
              <h2>Award Winning Projects</h2>
              <h3>RECENT WORK</h3>
            </div>

            <div className="lists">
              {mydata['projects'].map((item, index) => (
                <div className="list_item" key={index}>
                  <div className="list_img">
                    <img width={200} height={200} src={item.imageSrc} alt="Project Thumbnail" />
                  </div>
                  <div className="list_content">
                    <h4>{item.title}</h4>
                    <p>{item.description}</p>
                  </div>
                </div>
              ))}

            </div>
          </div>
        </div>

        <div className='client_testimonial'>
          <div className='page_wrapper'>
            <div className='inner_testimonial'>
              <h2>What My Clients Say</h2>
              <p>"Working with this developer was a game-changer for our project. Highly recommend!"</p>
            </div>

            <ul>
              <li>
                <div className='client_data custom_data black_color'>
                  <p>
                    I've worked with 50+ happy clients
                  </p>

                  <div className='counter'>
                    <span className='number'>98%</span>
                    <span className='txt'>Satisfaction Rate</span>
                  </div>
                </div>
              </li>

              <li>
                <div className='client_data custom_data blue_color'>
                  <p>
                    My work helped clients grow their revenue by 200%
                  </p>

                  <div className='counter'>
                    <span className='number'>200%</span>
                    <span className='txt'>Revenue Growth</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default App;